import { LoginResult, User, UserSession, UserSettingLegacy } from '../Types/user';
import { get, post, removeToken } from './common';

export function IsLoggedIn(user: User) {
	return user.Id > 0;
}

const userEndpoint = 'api/user';
const profileEndPoint = 'api/profile';
const simulationEndPoint = 'api/usersimulation';

export async function login(userName: string, password: string) {
	const endpoint = `${userEndpoint}/Login`;
	const result = await post<LoginResult>(endpoint, { UserName: userName, Password: password });
	//really never should need to set token here because login requires cookies, and the token is set to cookie from backend.
	// if (result?.Token) {
	// 	setToken(result.Token, result?.Id);
	// }
	removeToken(); //but we do need to clear any possible non-logged-in tokens left in storage
	return result;
}

export async function logout() {
	const endpoint = `${userEndpoint}/logout`;
	const redirectUrl = await post<string>(endpoint, {});
	removeToken(); //if exists
	return redirectUrl;
}

export async function getUserSession() {
	const endpoint = `${userEndpoint}/GetLoggedInUserSession`;
	const result = await get<UserSession>(endpoint);
	return result;
}

export async function getRelatedUsers() {
	const endpoint = `${profileEndPoint}/GetRelatedUsers`;
	const result = await get<User[]>(endpoint);
	return result;
}

export async function getUserProfile(userId: number) {
	const endpoint = `${profileEndPoint}/GetUserProfile?userId=${userId}`;
	const result = await get<User>(endpoint);
	return result;
}

export async function getUserSetting(key: string) {
	const endpoint = `${userEndpoint}/GetLoggedInUserSetting?key=${key}`;
	const value = await get<string>(endpoint);
	return value;
}

export async function setUserSetting(key: string, value: string) {
	const endpoint = `${userEndpoint}/UpdateUserSetting`;
	const result = await post<UserSettingLegacy>(endpoint, { Key: key, Value: value });
	return result;
}

export async function updateUserSession() {
	const endpoint = `${userEndpoint}/UpdateUserSession`;
	await get(endpoint);
}

export const getInitials = (fullname: string | null | undefined) => {
	if (fullname) {
		return fullname
			.split(' ')
			.map((n) => n[0])
			.join('')
			.substring(0, 2)
			.toUpperCase();
	}

	return '';
};

export async function initiateLimitedAccessMode(unitId: number) {
	const endpoint = `${simulationEndPoint}/InitiateLimitedAccessMode?unitId=${unitId}`;
	await post(endpoint);
}

export async function exitLimitedAccessMode() {
	const endpoint = `${simulationEndPoint}/ExitLimitedAccessMode`;
	await post(endpoint);
}
